import Swal from 'sweetalert2';

/**
 * Connects the user's wallet right where they are (the "Connect" buttons of Retire CO2, Marketplace, My orders and the
 * account menu). Those buttons used to send them to /dashboard, which is now the sign-in page: a signed-in user was
 * bounced to the home page and the wallet never got connected.
 * Not signed in -> the sign-in page, whose "Continue with your wallet" signs in and connects the wallet at once.
 * Resolves true when the wallet ended up connected.
 */
export async function connectWallet(store, router) {
  if (!store.getters['user/isWeb2UserConnected']) {
    router.push('/dashboard').catch(() => {});
    return false;
  }
  if (!window.ethereum) {
    Swal.fire({
      icon: 'info',
      title: 'No wallet found',
      html: 'Install <a href="https://metamask.io/download/" target="_blank" rel="noopener">MetaMask</a> '
        + '(or open this page in your wallet\'s browser) and try again.',
    });
    return false;
  }
  try {
    // on the wrong network it shows the "change chain" dialog and connects once the chain changes
    await store.dispatch('accounts/connectWeb3Modal');
  } catch (e) {
    const message = String((e && e.message) || e || '');
    // the person closed the wallet window or rejected the request: nothing to report
    if (!/closed by user|user rejected|rejected the request/i.test(message)) {
      Swal.fire('Error', `The wallet could not be connected. ${message}`, 'error');
    }
  }
  return store.getters['accounts/isUserConnected'];
}
